import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { LinkButton } from "../../components/ui/LinkButton";
import axios from "axios";
import { message } from "../../utils/toast";
import Preview from "../../components/layouts/Preview";
import { SERVER_URL } from "../../utils/config";

const PublicProfile = () => {
  const { leadId } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({});

  useEffect(() => {
    axios
      .get(`${SERVER_URL}/api/profile?leadId=${leadId}`)
      .then(({ data }) => {
        setFormData(data);
      })
      .catch((error) => {
        message({ type: "error", content: error.message });
      });
  }, [leadId, navigate]);

  return (
    <div className="flex-1 p-2">
      <div className="overflow-y-auto">
        <div className="border-b bg-white shadow-sm py-4 px-6 flex justify-end mb-4">
          {formData.button_three_text && formData.button_three_link && (
            <LinkButton
              onClick={() => {
                window.open(formData.button_three_link, "_blank");
              }}
              className="text-[1.2rem] float-right"
            >
              {formData.button_three_text.includes("{{first_name}}")
                ? formData.button_three_text.replace(
                    "{{first_name}}",
                    formData.lead_name.split(" ")[0]
                  )
                : formData.button_three_text}
            </LinkButton>
          )}
        </div>
        <Preview formData={formData} />
      </div>
    </div>
  );
};

export default PublicProfile;
